export type QuarterOption = {
    key: string;
    label: string;
    year: number;
    quarter: number;
};

export type DynamicQuarterOption = QuarterOption & {
    isDynamic?: boolean;
};

function getQuarterForOffset(referenceDate: Date, offset: number) {
    const currentQuarter = Math.floor(referenceDate.getMonth() / 3) + 1;
    let quarter = currentQuarter + offset;
    let year = referenceDate.getFullYear();

    while (quarter <= 0) {
        quarter += 4;
        year -= 1;
    }

    while (quarter > 4) {
        quarter -= 4;
        year += 1;
    }

    return { year, quarter };
}

export function formatQuarterLabel(year: number, quarter: number) {
    return `Q${quarter} ${year}`;
}

export function buildQuarterKey(year: number, quarter: number) {
    return `${year}_q${quarter}`;
}

export function buildDynamicQuarterKey(year: number, quarter: number): string {
    return `${year}_q${quarter}_dynamicestimates`;
}

export function generateQuarterOptions(
    referenceDate = new Date(),
    count = 4,
    includeDynamic = true,
    dynamicLabel?: string
): DynamicQuarterOption[] {
    const options: DynamicQuarterOption[] = [];

    if (includeDynamic) {
        // Add dynamic estimates as first option (current quarter)
        const currentDate = new Date(referenceDate);
        const { year, quarter } = getQuarterForOffset(currentDate, 0);
        options.push({
            year,
            quarter,
            key: buildDynamicQuarterKey(year, quarter),
            label: dynamicLabel || 'Current quarter (dynamic)',
            isDynamic: true,
        });
    }

    // Generate preceding quarters (start from -1 to skip current quarter)
    const startOffset = includeDynamic ? -1 : 0;
    for (let i = 0; i < count; i++) {
        const { year, quarter } = getQuarterForOffset(referenceDate, startOffset - i);
        options.push({
            year,
            quarter,
            key: buildQuarterKey(year, quarter),
            label: formatQuarterLabel(year, quarter),
        });
    }

    return options;
}
